$(document).ready(function() {
  $("[data-behavior='delete-image']").on('ajax:success', function(event) {
    $(this).parents('[data-behavior="image-container"]').remove()
  })
})
